import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import '../Div/index.js';
import { composeRichTextComponents } from './options/composeRichTextComponents.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
const SPACING_TOP = 3;
const defaultOptions = composeRichTextComponents({
  hasOverrideContentfulParagraphWrapping: true
});
function RichText({
  content,
  color = 'foreground',
  foregroundInlineLink = 'blue60',
  defaultSpacingTop = SPACING_TOP,
  paragraphSpacingTop,
  secondaryColor = 'foregroundMuted',
  richTextOptions = defaultOptions
}) {
  return /*#__PURE__*/jsx(Div, {
    display: "contents",
    className: "rich-text",
    children: documentToReactComponents(content, richTextOptions({
      color,
      foregroundInlineLink,
      defaultSpacingTop,
      paragraphSpacingTop,
      secondaryColor
    }))
  });
}
export { RichText };
//# sourceMappingURL=RichText.js.map
